import { RouteConfigProvider } from '@/context/route-config';
import AmlQuestionnaireForm, { type AmlQuestionnaireRouteConfig } from '@/features/onboarding/aml-questionnaire/components/form';
import AmlQuestionnaireLayout from '@/features/onboarding/aml-questionnaire/layout';
import { PERIODIC_REVIEW_PATHS } from '@/features/periodic-review/constants';

const ROUTE_CONFIG = {
  next: PERIODIC_REVIEW_PATHS.SUMMARY,
  personalInformation: PERIODIC_REVIEW_PATHS.PERSONAL_INFORMATION,
} satisfies AmlQuestionnaireRouteConfig;

const PeriodicReviewAmlQuestionnairePage = () => {
  return (
    <AmlQuestionnaireLayout>
      <RouteConfigProvider config={ROUTE_CONFIG}>
        <AmlQuestionnaireForm />
      </RouteConfigProvider>
    </AmlQuestionnaireLayout>
  );
};
PeriodicReviewAmlQuestionnairePage.displayName = 'PeriodicReviewAmlQuestionnairePage';

export default PeriodicReviewAmlQuestionnairePage;
